




































import { Component, Vue, Prop } from 'vue-property-decorator';
import DottedBorderBox from '~/components/UIComponents/DottedBorderBox.vue';

@Component({
  components: {
    DottedBorderBox,
  },
})
export default class IsRestrictedBlock extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly value!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly message!: boolean;

  @Prop({ type: String, default: false })
  readonly reason!: string;

  @Prop({ type: String, default: false })
  readonly hasRestriction!: string;
}
